import Branch from 'branch-sdk'

export const sendEvent = (event) => {
  Branch.logEvent(event)
}

export default {
  sendEvent,
}
